import { XMarkIcon } from '@heroicons/react/24/outline';
import React, { useEffect } from 'react';
import PDFViewer from '../../components/PDFViewer';
import { VideoPlayer } from '../../components/VideoPlayer';
import { useChatConfig } from '../context/ChatConfigContext';

type PreviewType = 'image' | 'pdf' | 'video';

interface FilePreviewModalProps {
    type: PreviewType;
    url: string;
    name?: string;
    onClose: () => void;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({ type, url, name, onClose }) => {
    const { apiBaseUrl, getAuthToken } = useChatConfig();
    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        document.addEventListener('keydown', handler);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handler);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    return (
        <div
            className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center"
            onClick={onClose}
        >
            <button
                onClick={onClose}
                className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors z-10"
            >
                <XMarkIcon className="w-8 h-8" />
            </button>

            {name && (
                <div className="absolute top-4 left-4 text-white/70 text-sm truncate max-w-[60%] z-10">
                    {name}
                </div>
            )}

            <div
                onClick={(e) => e.stopPropagation()}
                className="flex items-center justify-center"
                style={{ width: '90vw', height: '90vh' }}
            >
                {type === 'image' && (
                    <img
                        src={url}
                        alt={name ?? ''}
                        className="max-w-full max-h-full object-contain rounded-lg"
                    />
                )}
                {type === 'video' && (
                    <div className="w-full max-w-5xl aspect-video rounded-lg overflow-hidden">
                        <VideoPlayer videoUrl={url} className="w-full h-full" />
                    </div>
                )}
                {type === 'pdf' && (
                    <div className="w-full h-full bg-white rounded-lg overflow-hidden p-4">
                        <PDFViewer
                            pdfUrl={url}
                            apiBaseUrl={apiBaseUrl}
                            showControls={true}
                            className="h-full"
                            getAuthToken={getAuthToken}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export { FilePreviewModal };
export type { PreviewType };
